<template>
    <div class="main-content bg-default">
        <!-- Navbar -->
        <base-nav class="navbar-top navbar-horizontal navbar-dark"
                  containerClasses="px-4 container"
                  expand>

            <a slot="brand" class="navbar-brand" :href="getportalUrl">
                <img src="img/brand/white.png"/>
            </a>

            <template v-slot="{closeMenu}">
                <!-- Collapse header -->
                <div class="navbar-collapse-header d-md-none">
                    <div class="row">
                        <div class="col-6 collapse-brand">
                            <router-link to="/">
                                <img src="img/brand/green.png">
                            </router-link>
                        </div>
                        <div class="col-6 collapse-close">
                            <button type="button"
                                    @click="closeMenu"
                                    class="navbar-toggler"
                                    aria-label="Toggle sidenav">
                                <span></span>
                                <span></span>
                            </button>
                        </div>
                    </div>
                </div>
                <!-- Navbar items -->
                <ul class="navbar-nav ml-auto">
                    <li class="nav-item">
                        <a class="nav-link nav-link-icon" :href="getportalUrl">
                            <i class="ni ni-planet"></i>
                            <span class="nav-link-inner--text">Dashboard</span>
                        </a>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link nav-link-icon" to="/login">
                            <i class="ni ni-single-02"></i>
                            <span class="nav-link-inner--text">Login</span>
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link nav-link-icon" to="/register">
                            <i class="ni ni-circle-08"></i>
                            <span class="nav-link-inner--text">Register</span>
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link nav-link-icon" to="/requirements">
                            <i class="ni ni-folder-17"></i>
                            <span class="nav-link-inner--text">Requirements</span>
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <a href="/user-guide.pdf" target="_blank" class="nav-link nav-link-icon">
                            <i class="ni ni-books"></i>
                            <span class="nav-link-inner--text">User Guide</span>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link nav-link-icon" :href="websiteUrl">
                            <i class="fa fa-home"></i>
                            <span class="nav-link-inner--text">Website Homepage</span>
                        </a>
                    </li>
                </ul>
            </template>
        </base-nav>
        <!-- Header -->
        <div class="header bg-gradient-danger py-7 py-lg-8">
            <div class="container">
                <div class="header-body text-center mb-7">
                    <div class="row justify-content-center">
                        <div class="col-lg-5 col-md-6">
                            <h1 class="text-capitalize">
                                {{this.$route.name}}
                            </h1>
                        </div>
                    </div>
                </div>
            </div>
            <div class="separator separator-bottom separator-skew zindex-100">
                <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
                     xmlns="http://www.w3.org/2000/svg">
                    <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
                </svg>
            </div>
        </div>
        <!-- Page content -->
        <div class="container mt--8 pb-5">
            <slide-y-up-transition mode="out-in" origin="center top">
                <router-view></router-view>
            </slide-y-up-transition>
        </div>
        <footer class="py-5">
            <div class="container">
                <div class="row align-items-center justify-content-xl-between">
                    <div class="col-xl-6">
                        <div class="copyright text-center text-xl-left text-white">
                            &copy; {{year}}
                            <a class="font-weight-bold ml-1">
                                Medical and Dental Council of Nigeria
                            </a>
                        </div>
                    </div>
                    <div class="col-xl-6">
                        <ul class="nav nav-footer justify-content-center justify-content-xl-end">
                            <div class="copyright text-center text-lg-left text-white">
                                Designed By
                                <a href="javascript:void(0)" target="_blank">
                                BCF
                                </a>
                            </div>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>
<script>
    import { SlideYUpTransition } from 'vue2-transitions'
    import { mapGetters } from 'vuex'

    export default {
        name: 'auth-layout',
        components: {
            SlideYUpTransition
        },
        data() {
            return {
                year: new Date().getFullYear(),
                showMenu: false
            }
        },
        computed: {
            ...mapGetters(['websiteUrl', 'getportalUrl'])
        }
    }
</script>
<style>
</style>
